import styled from 'styled-components';
import GuestSvg from '../../assets/mytrips/guests.svg';

const GuestIcon = styled(GuestSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.6rem'};
  height: ${props => props.height || '1.6rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default GuestIcon;
